import React from "react";
import { Result, Button, Card } from "antd";
import { ExclamationCircleOutlined, MailOutlined } from "@ant-design/icons";
import "./BlockedAccountOverlay.scss";

const BlockedAccountOverlay = ({ client }) => {
  const handleCallSupport = () => {
    window.location.href = "mailto:support@goflexio.com"; // Replace with actual support number
  };

  return (
    <div className="blocked-account-overlay">
      <div className="blocked-account-content">
        <Card
          className="blocked-account-card"
          style={{
            backgroundColor: "#ffebee",
            border: "2px solid #ffcdd2",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(255, 77, 79, 0.12)"
          }}
        >
          <Result
            icon={<ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />}
            title={
              <span style={{ color: "#ff4d4f", fontSize: "24px", fontWeight: "600" }}>
                Account Currently Blocked
              </span>
            }
            subTitle={
              <div style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                <p style={{ marginBottom: "16px" }}>
                  Your account has been temporarily blocked and you cannot access the
                  system at this time.
                </p>
                <p style={{ marginBottom: "24px" }}>
                  Please contact Flexio Administration to resolve this issue and reopen
                  your account.
                </p>

                {client && (
                  <div
                    style={{
                      backgroundColor: "#fff",
                      padding: "16px",
                      borderRadius: "8px",
                      border: "1px solid #ffcdd2",
                      marginBottom: "24px",
                      textAlign: "left"
                    }}
                  >
                    {client.blockedAt && (
                      <p>
                        <strong>Blocked At:</strong>{" "}
                        {new Date(client.blockedAt).toLocaleString()}
                      </p>
                    )}
                    {client.blockReason && (
                      <p>
                        <strong>Reason:</strong> {client.blockReason}
                      </p>
                    )}
                  </div>
                )}
              </div>
            }
            extra={[
              <Button
                key="support"
                type="primary"
                size="large"
                icon={<MailOutlined />}
                onClick={handleCallSupport}
                style={{
                  backgroundColor: "#ff4d4f",
                  borderColor: "#ff4d4f",
                  height: "48px",
                  fontSize: "16px",
                  fontWeight: "500"
                }}
              >
                Contact Flexio Support
              </Button>
            ]}
          />
        </Card>
      </div>
    </div>
  );
};

export default BlockedAccountOverlay;
